import { Middleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise';

import errorMiddleware from './onPromiseError';
import { epics } from './rootEpic';

export const epicMiddleware = createEpicMiddleware();

export const middlewareCollection: Middleware[] = [
  errorMiddleware,
  promiseMiddleware,
  thunkMiddleware,
  epicMiddleware,
  // createLogger()
];

/**
 * Setup epics
 */
export const rootEpic = epics();
